import { DataGrid, EntityDialog, HtmlContentEditor } from "@serenity-is/corelib";
import { gridDefaults } from "@serenity-is/sleekgrid";
import { Authorization, Config, ErrorHandling, text } from "@serenity-is/corelib/q";
import { IdleTimeout } from "@serenity-is/pro.extensions";
import { siteLanguageList } from "./Helpers/LanguageList";

Config.rootNamespaces.push('Dablk4');
EntityDialog.defaultLanguageList = siteLanguageList;
gridDefaults.useCssVars = true;
HtmlContentEditor.CKEditorBasePath = "~/Serenity.Assets/Scripts/ckeditor/";

if ($.fn['colorbox']) {
    $.fn['colorbox'].settings.maxWidth = "95%";
    $.fn['colorbox'].settings.maxHeight = "95%";
}

window.onerror = ErrorHandling.runtimeErrorHandler;

//DataGrid.defaultPersistanceStorage = window.sessionStorage;
DataGrid.defaultPersistanceStorage = window.localStorage;
var sDABConfiguration = text("MyCabinet.LKDABConfiguration.DABConfiguration").toLowerCase();

$(() => {
    var activityTimeoutMin = 15;

    if (sDABConfiguration == "zenit") {
        activityTimeoutMin = 10;
    }

    // let demo page use its own settings for idle timeout
    if (window.location.pathname.indexOf('Samples/IdleTimeout') > 0)
        return;

    var meta = $('meta[name=username]');
    if ((meta.length && meta.attr('content')) ||
        (!meta.length && Authorization.isLoggedIn)) {

        new IdleTimeout({
            activityTimeout: activityTimeoutMin * 60,
            warningDuration: 2 * 60
        });
    }
});